<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Staff List">
        <v-card-component>
          <v-card-text class="pt-0 pr-1"
            :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search" hide-details single-line
              style="max-width:350px;" />
            <v-btn v-on:click="addStaff()" v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
              color="accent">
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-skeleton-loader v-if="staffData.length === 0" type="table-thead, table-tbody"></v-skeleton-loader>
          <v-data-table v-else :single-expand="singleExpand" :expanded.sync="expanded" item-key="id" show-expand
            :items="staffData" :search.sync="search" :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }" :items-per-page="10" :headers="headers">
            <template v-slot:item.userStaff.mobileNo="{ item }">
              <div v-if="!showData && item.exceptionRoles">
                <span>{{ item.userStaff.mobileNo.replace(item.userStaff.mobileNo.substring(item.userStaff.mobileNo, 5, 5),
                  '*****') }}</span>
              </div>
              <div v-else>
                <span>{{ item.userStaff.mobileNo }} </span>
              </div>
            </template>
            <template v-slot:item.userStaff.status="{ item }">
              <div :class="getColor(item.userStaff.status)">
                {{ item.userStaff.status }}
              </div>

              <div v-if="modules.StaffApproval">
                <div
                  v-if="item.userStaff.addharCardUrl && item.userStaff.panCardUrl && item.userStaff.educationalDocUrl && item.userStaff.status !== 'APPROVED' && item.userStaff.status !== 'FAIL'">
                  <v-btn class="px-2 ml-1 ma-1" outlined color="success" min-width="0" small @click.prevent="() => {
                    openModal(item.userStaff.userID, 'true'), (isApproved = true)
                  }
                    ">
                    Approve
                  </v-btn>
                  <v-btn class="px-2 ml-1 ma-1" outlined color="error" min-width="0" small @click.prevent="() => {
                    openModal(item.userStaff.userID, 'true'), (isApproved = false)
                  }
                    ">
                    Reject
                  </v-btn>
                </div>
                <div
                  v-else-if="item.userStaff.aadharCardFrontPhoto && item.userStaff.aadharCardBackPhoto && item.userStaff.policeVerificationPhoto  && item.userStaff.status !== 'APPROVED' && item.userStaff.status !== 'FAIL'">
                  <v-btn class="px-2 ml-1 ma-1" outlined color="success" min-width="0" small @click.prevent="() => {
                    openModal(item.userStaff.userID, 'true'), (isApproved = true)
                  }
                    ">
                    Approve
                  </v-btn>
                  <v-btn class="px-2 ml-1 ma-1" outlined color="error" min-width="0" small @click.prevent="() => {
                    openModal(item.userStaff.userID, 'true'), (isApproved = false)
                  }
                    ">
                    Reject
                  </v-btn>
                </div>
              </div>
            </template>
            <template v-slot:item.documents="{ item }">
              <div v-if="!showData && item.exceptionRoles"><span></span></div>
              <div v-else>
                <v-row no-gutters>
                  <v-col cols="12" md="11" class="ma-0 pa-0">
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.addharCardUrl" @click="openFile(item.userStaff.addharCardUrl)">Aadhar Card
                    </v-btn>

                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.panCardUrl" @click="openFile(item.userStaff.panCardUrl)">Pan Card</v-btn>

                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.educationalDocUrl"
                      @click="openFile(item.userStaff.educationalDocUrl)">Educational docs</v-btn>
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.resumeUrl" @click="openFile(item.userStaff.resumeUrl)">Resume</v-btn>
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.imageUrl" @click="openFile(item.userStaff.imageUrl)">Image</v-btn>
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.codeOfConductUrl" @click="openFile(item.userStaff.codeOfConductUrl)">Code of Conduct</v-btn>
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.busAttendentPhoto" @click="openFile(item.userStaff.busAttendentPhoto)">Bus Attendent Image</v-btn>
                    <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.aadharCardFrontPhoto" @click="openFile(item.userStaff.aadharCardFrontPhoto)">Aadhar Front Image </v-btn>
                      <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.aadharCardBackPhoto" @click="openFile(item.userStaff.aadharCardBackPhoto)">Aadhar Back Image</v-btn>
                      <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                      v-if="item.userStaff.policeVerificationPhoto" @click="openFile(item.userStaff.policeVerificationPhoto)">Police Verification Image</v-btn>
                  </v-col>
                  <v-col cols="12" md="1" class="ma-0 pa-0">
                    <div class="d-flex justify-end"
                      v-if="item.userStaff.addharCardUrl || item.userStaff.panCardUrl || item.userStaff.educationalDocUrl">
                      <v-icon small> mdi-open-in-new</v-icon>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template :visible="modules.ActiveDeactive" v-slot:item.activeDeactive="{ item }">
              <div v-if="item.userStaff.status === 'APPROVED'">
                <v-btn v-if="item.userStaff.isActive"
                  @click.prevent="activeDeactive(item.userStaff.userID, 'Deactivated')" title="Deactivate User"
                  class="px-2 ml-1 ma-1" color="error" min-width="0" small :disabled="!showData && item.exceptionRoles">
                  <v-icon small>mdi-account-off</v-icon>
                </v-btn>
                <v-btn v-else @click.prevent="activeDeactive(item.userStaff.userID, 'Activated')" title="Restore User"
                  class="px-2 ml-1 ma-1" color="info" min-width="0" small :disabled="!showData && item.exceptionRoles">
                  <v-icon small>mdi-restore</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:item.classMap="{ item }">
              <div v-if="item.userStaff.status === 'APPROVED'">
                <v-btn @click.prevent="openModal(item.userStaff.userID, 'false')" title="Assign Class"
                  v-if="modules.ClassMap" class="px-2 ml-1 ma-1" color="success" min-width="0" small
                  :disabled="!showData && item.exceptionRoles">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn class="px-2 ml-1 ma-1" min-width="0" small @click.prevent="() => {
                  ; (viewModalOk = true), (userID = item.userStaff.userID)
                }
                  " :disabled="!showData && item.exceptionRoles">
                  <v-icon color="black" small>mdi-eye</v-icon>
                </v-btn>
              </div>
            </template>
            <template :visible="isWrite" v-slot:item.actions="{ item }">
              <router-link :to="{ name: 'staffUserEdit', params: { staffId: item.userStaff.userID } }"
                >
                <v-btn outlined color="success" class="px-2 ml-1 ma-1" min-width="0" small
                  >
                  Edit Staff
                </v-btn>
              </router-link>
              <v-btn outlined class="px-2 ml-1 ma-1" @click="getApprovalLogs(item.userStaff.userID)" min-width="0" small
                :disabled="!showData && item.exceptionRoles">
                Approval logs
              </v-btn>

              <v-btn color="warning" v-if="item.userStaff.status === 'PENDING'" outlined class="px-2 ml-1 ma-1"
                @click="sendLoginURL(item.userStaff.userID)" min-width="0" small
                :disabled="!showData && item.exceptionRoles">
                Send login URL
              </v-btn>
            </template>
            <template v-if="showData" v-slot:expanded-item="{ headers, item }">
              <td class="pa-4" :colspan="headers.length">
                <v-row>
                  <v-col cols="12" md="3">
                    <tr>
                      <div class="font-weight-bold body-2 subtitle">
                        Email:
                        <span class=" body-2 subtitle">
                          {{ item.email }}
                        </span>
                      </div>
                      <div class="font-weight-bold body-2 subtitle">
                        Pan:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.panCard }}
                        </span>
                      </div>
                    </tr>
                  </v-col>

                  <v-col cols="12" md="3">
                    <tr>
                      <div class="font-weight-bold body-2 subtitle">
                        Aadhar:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.addharCard }}
                        </span>
                      </div>
                      <div class="font-weight-bold body-2 subtitle">
                        Teaching Staff:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.isTeachingStaff ? 'Yes' : 'No' }}
                        </span>
                      </div>
                    </tr>
                  </v-col>

                  <v-col cols="12" md="3">
                    <tr>
                      <div class="font-weight-bold body-2 subtitle">
                        Address:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.address }}
                        </span>
                      </div>
                      <div class="font-weight-bold body-2 subtitle">
                        City:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.city }}
                        </span>
                      </div>
                    </tr>
                  </v-col>

                  <v-col cols="12" md="3">
                    <tr>
                      <div class="font-weight-bold body-2 subtitle">
                        State:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.state }}
                        </span>
                      </div>
                      <div class="font-weight-bold body-2 subtitle">
                        Country:
                        <span class=" body-2 subtitle">
                          {{ item.userStaff.country }}
                        </span>
                      </div>
                    </tr>
                  </v-col>
                </v-row>
              </td>
            </template>

            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <v-dialog persistent :on-cancel="() => {
        clrModalData()
      }
        " v-model="viewModalOk" :active="viewModalOk" max-width="650">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> View Class</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="viewModalOk = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete label="Academic Year*" placeholder="--Select--" v-model="academicYearID"
                    :items="academicYears" key="id" item-value="id" item-text="academicYear"> </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn elevation="1" color="success" @click="getClassData(userID)">
                    <v-icon left>mdi-magnify</v-icon>
                    Get
                  </v-btn>
                </v-col>
                <v-col cols="12" v-if="apiCalled">
                  <v-simple-table v-if="classMapData.length > 0">
                    <template>
                      <thead>
                        <tr>
                          <th id="class" class="text-left">
                            Class
                          </th>
                          <th id="section" class="text-left">
                            Section
                          </th>
                        </tr>
                      </thead>
                      <tbody v-for="(data, i) in classMapData" :key="i">
                        <tr>
                          <td>{{ data.studentSection.studentClass.name }}</td>
                          <td>{{ data.studentSection.name }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-card-subtitle v-else>No classes assigned to this Staff.</v-card-subtitle>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="modalOk" :active="modalOk" fullscreen hide-overlay
        transition="dialog-bottom-transition" :on-cancel="() => {
          clrModalData(), (modalOk = false), (academicYearID = ''), (selectedClasses = []), (sectionID = []), (sectionarray = [])
        }
          ">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Edit Staff</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="() => {
                clrModalData(), (modalOk = false), (academicYearID = ''), (selectedClasses = []), (sectionID = []), (sectionarray = [])
              }
                ">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-sheet class="overflow-y-auto mt-8">
            <v-container>
              <div v-if="approveAction === 'true'">
                <v-row>
                  <v-col cols="12" md="8">
                    <label class="font-weight-medium body-2">{{ isApproved ? 'Approve' : 'Reject' }} Remark <span
                        class="error--text">*</span></label>
                    <v-textarea required outlined clear-icon="mdi-close-circle" clearable v-model.trim="remark"
                      placeholder="Remark..." rows="3"></v-textarea>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="font-weight-medium body-2">Select File </label>
                    <v-file-input :messages="['(max file size allowed 20MB)']" class="my-0 py-1" v-model="dropFile"
                      accept="application/pdf" @input="onFilechange()" show-size placeholder="Click to Upload">
                    </v-file-input>
                    <div v-if="dropFile && dropFile.name">
                      <v-chip color="primary" close @click:close="() => {
                        this.dropFile = []
                      }
                        " label outlined class="ma-2">
                        {{ dropFile.name }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-autocomplete label="Academic Year *" clearable v-model="academicYearID" :items="academicYears"
                      key="id" item-value="id" item-text="academicYear"> </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete label="Franchisee *" placeholder="--Select--" v-model="franchiseeID"
                      :items="userFranchiseeMapList" key="id" item-value="id" item-text="companyName">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn @click="getClassList()" bottom right elevation="1" color="success">
                      <v-icon left> mdi-magnify </v-icon>
                      Get
                    </v-btn>
                  </v-col>
                  <v-col cols="12" v-if="showCount">
                    <label class="font-weight-bold body-2">Class (Student count)</label>
                    <v-row no-gutters>
                      <v-col cols="12" md="3" v-for="c in classes" :key="c.id">
                        <v-checkbox @change="classPick" v-model="selectedClasses" :value="c.id"
                          :label="c.name + ` (${c.studentClassCount})`"> </v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3" v-for="(a, i) in sectionarray" :key="i">
                    <label class="font-weight-bold body-2">{{ a.name }}</label>
                    <v-row no-gutters>
                      <v-col cols="12" v-for="(b, j) in a.studentSections" :key="j">
                        <v-checkbox v-model="sectionID" :value="b.id"
                          :label="b.name + '  (' + b.studentSectionCount + ')'"> </v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                  <v-card-actions class="justify-end">
                    <v-btn @click="() => {
                      clrModalData(), (modalOk = false), (academicYearID = ''), (selectedClasses = []), (sectionID = []), (sectionarray = [])
                    }
                      ">Close</v-btn>
                    <v-btn v-if="approveAction === 'true'" color="primary" @click="statusSave">Save</v-btn>
                    <v-btn v-else @click="mapSave" color="primary">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-card>
      </v-dialog>

      <v-dialog max-width="900px" v-model="logModalOk" :active="logModalOk" :on-cancel="() => {
        logModalOk = false
      }
        ">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Approval Logs</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="logModalOk = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-data-table hide-default-footer :items="logData" :headers="headers2">
                <template v-slot:item.urlPath="{ item }">
                  <v-btn text outlined class="px-2 ml-1 ma-1" min-width="0" color="primary" small v-if="item.urlPath"
                    @click="openFile(item.urlPath)">Download</v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import stores from '@/stores'
import Utils from '@/utils'
import _ from 'lodash'

import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'staffList',
  components: {
    VCardComponent,
    MaterialCard
  },
  data () {
    return {
      modules: {
        OtherActions: this.checkModuleAccess('OtherActions'),
        ClassMap: this.checkModuleAccess('ClassMap'),
        StaffApproval: this.checkModuleAccess('StaffApproval'),
        DownloadDocuments: this.checkModuleAccess('DownloadDocuments'),
        ActiveDeactive: this.checkModuleAccess('ActiveDeactive')
      },
      staffData: [],
      expanded: [],
      isSuperAdmin: false,
      singleExpand: true,
      searchTerm: '',
      isLoading: false,
      viewModalOk: false,
      total: '',
      search: '',
      user: stores.user,
      modalOk: false,
      isApproved: true,
      userID: '',
      statusColumn: true,
      approveAction: null,
      academicYears: [],
      academicYearID: '',
      classes: [],
      sections: [],
      selectedClasses: [],
      selectedSections: [],
      sectionarray: [],
      sectionID: [],
      classMapData: [],
      currentPage: 1,
      temp: [],
      isWrite: false,
      fetchCurrentYearOnly: true,
      remark: '',
      franchiseeList: [],
      franchiseeID: '',
      showCount: false,
      apiCalled: false,
      searchFilterArray: [],
      dropFile: null,
      logData: [],
      logModalOk: false,
      allSectionArray: [],
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Gender', value: 'userStaff.gender', sortable: false },
        { text: 'DOJ', value: 'userStaff.dateOfJoining', sortable: false },
        { text: 'Mobile', value: 'userStaff.mobileNo', sortable: false },
        { text: 'Status', value: 'userStaff.status', sortable: true },
        { text: 'Documents', value: 'documents', sortable: false },
        { text: 'Active/Deactive', value: 'activeDeactive', align: 'center', sortable: false },
        { text: 'Class', value: 'classMap', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      headers2: [
        { text: 'Status before', value: 'statusBefore', sortable: false },
        { text: 'Status after', value: 'statusAfter', sortable: false },
        { text: 'Approved by', value: 'createdBy', sortable: false },
        { text: 'Remark', value: 'remark', sortable: false },
        { text: 'Updated at', value: 'updatedAt', sortable: false },
        { text: 'Document', value: 'urlPath', align: 'center', sortable: false }
      ],
      userFranchiseeMapList: [],
      exceptionRoles: false,
      showData: false
    }
  },
  created: async function () {
    this.isSuperAdmin = Utils.helper.isSuperAdmin()
    if (this.isSuperAdmin) {
      this.fetchCurrentYearOnly = false
    }
    let userStore = stores.user
    this.showData = userStore.ACL.superAdmin

    await this.getYearList()
    if (this.franchisee.id) {
      this.franchiseeID = this.franchisee.id
    }
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  mounted: async function () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onFranchiseeChange()
      }
    }
  },
  methods: {
    sendLoginURL: async function (id) {
      this.$dialog.warning({
        text: 'Are you sure, you want to send URL via email ?',
        title: 'Warning',
        actions: {
          false: 'No',
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                let res = await http.post(`${constants.API_URL}/api/admin/user/staff/mail/${id}`)
                this.okMsg(res.data)
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    getColor (status) {
      if (status === 'APPROVED') return 'v-green font-weight-bold'
      else if (status === 'FAIL') return 'v-error font-weight-bold'
      else if (status === 'PENDING') return 'v-warning font-weight-bold'
      else return 'v-secondary '
    },
    getApprovalLogs: async function (id) {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/staff/approval/details/${id}`)
        this.logModalOk = true
        this.logData = res.data
        this.logData.map(a => {
          a.updatedAt = moment(a.updatedAt, 'YYYY-MM-DD').format('YYYY-MM-DD')
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFilechange () {
      if (this.dropFile.type !== 'application/pdf') {
        this.errMsg('Kindly select only .pdf format file!')
        this.dropFile = []
        return false
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getClassList: async function () {
      if (this.academicYearID === '') {
        this.errMsg('Kindly select Academic year!')
        return false
      }
      this.showCount = true
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/student/all-count-edit-staff?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=false`)
        const data = response.data
        this.classes = data
        this.sections = data
        this.classPick()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
        await this.getClassData(this.userID)
      }
    },
    getClassData: async function (uid) {
      if (this.academicYearID === '') {
        this.errMsg('Kindly select academic year!')
        return false
      }
      try {
        this.isLoading = true

        let res = await http.get(`${constants.API_URL}/api/staff/teacher-class-map-edit-staff?franchiseeID=${this.franchiseeID}&userID=${uid}&&academicYearID=${this.academicYearID}&&isActive=true`)
        this.classMapData = res.data
        this.selectedClasses = []
        this.sectionID = []
        if (this.classMapData.length > 0) {
          this.selectedClasses = this.classMapData.map(a => a.studentSection.studentClass.id).filter((a, b, c) => c.indexOf(a) === b)
          this.sectionID = this.classMapData.map(a => a.studentSection.id)
        } else {
          this.selectedClasses = []
          this.sectionID = []
        }
        this.classPick()
        this.apiCalled = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    mapSave: async function () {
      if (this.academicYearID === '') {
        this.errMsg('Kindly select academic year!!')
        return false
      } else if (this.selectedClasses.length === 0) {
        this.errMsg('Kindly select class!!')
        return false
      } else if (this.sectionID.length === 0) {
        this.errMsg('Kindly select section!!')
        return false
      }
      let fn = []
      this.classes.map(a => {
        if (a.studentSections) {
          a.studentSections.map(b => {
            let r = this.sectionID.includes(b.id)
            if (r) {
              fn.push({
                sectionID: b.id,
                isActive: true
              })
            } else {
              fn.push({
                sectionID: b.id,
                isActive: false
              })
            }
          })
        }
      })
      try {
        this.isLoading = true
        if (this.franchiseeID !== '') {
          this.franchiseeID = this.franchiseeID.toString()
        }
        await http.post(`${constants.API_URL}/api/staff/teacher-class-map`, {
          franchiseeID: this.franchiseeID,
          studentSection: fn,
          userID: this.userID,
          academicYearID: this.academicYearID
        })
        this.modalOk = false
        this.okMsg('Class assigned successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
        this.selectedClasses = []
        this.sectionID = []
        this.sectionarray = []
        this.clrModalData()
      }
    },
    classPick () {
      if (this.selectedClasses.length === 0) {
        this.sectionarray = this.sections
        this.selectedClasses = this.sections.map(a => a.id)
        this.sectionID = this.sections.flatMap(a => (a.studentSections ? a.studentSections.map(b => b.id) : []))
      } else {
        this.sectionarray = this.sections.filter(a => {
          let sectionarray = this.selectedClasses.find(obj => obj === a.id)
          return sectionarray
        })

        // update sectionid array
        let n = []
        this.sectionarray.map(a => {
          if (a.studentSections) {
            a.studentSections.map(b => {
              this.sectionID.map(c => {
                if (c === b.id) {
                  n.push(c)
                }
              })
            })
          }
        })
        this.sectionID = _.uniq(n)
      }
    },

    getYearList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=${this.fetchCurrentYearOnly}`)
        this.academicYears = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    openFile: async function (path) {
      if (this.modules.DownloadDocuments) {
        try {
          this.isLoading = true
          let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`)
          window.open(url.data)
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(`Error While getting file details, ${errorMessage}`)
        } finally {
          this.isLoading = false
        }
      } else {
        this.errMsg('You dont have access!')
        return false
      }
    },
    statusSave: async function () {
      if (!this.remark) {
        this.errMsg('Remark cannot be empty!')
        return false
      }
      try {
        this.isLoading = true
        let formData = new FormData()
        formData.append('isApproved', this.isApproved)
        formData.append('remark', this.remark)

        if (this.dropFile && this.dropFile !== null && this.dropFile !== undefined && this.dropFile.length !== 0) {
          formData.append('file', this.dropFile)
        }

        let res = await http.post(`${constants.API_URL}/api/staff/approval/${this.userID}`, formData)
        this.modalOk = false
        this.okMsg(res.data)
        this.statusColumn = false
        await this.getTeachersData(this.franchiseeID)
      } catch (e) {
        this.modalOk = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While updating staff, ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
      this.isApproved = true
      this.remark = ''
      this.dropFile = []
    },
    openModal: async function (id, action) {
      this.modalOk = true
      this.userID = id
      this.approveAction = action
      await this.getUserFranchiseeList()
    },
    getUserFranchiseeList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/staff/get-user-franchisee-list/${this.userID}`)
        if (response.status === 200) {
          // this.franchiseeList = [{ id: '', companyName: 'Select All' }].concat(response.data.rows)
          this.userFranchiseeMapList = [{ id: '', companyName: 'Select All' }].concat(response.data)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While updating staff, ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    activeDeactive: async function (id, action) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/staff/status/${id}`)
        this.okMsg(`Staff ${action} successfully !`)

        await this.getTeachersData(this.franchiseeID)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While updating staff, ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    clrModalData () {
      this.viewModalOk = false
      this.academicYearID = ''
      this.classMapData = []
      this.userID = ''
      this.selectedClasses = []
      this.apiCalled = false
      this.showCount = false
      this.dropFile = []
      this.remark = ''
      this.sectionarray = []
      this.sectionID = []
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    onFranchiseeChange: async function () {
      this.searchFilterArray = []
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee && this.franchisee.id) {
          this.franchiseeID = this.franchisee.id
        } else {
          let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
          this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
        }

        this.currentPage = 1
        this.statusColumn = false
        await this.getTeachersData(this.franchiseeID)
        this.inProgress = false
      }
    },
    getFranchiseeDataFromIndexDB: function () {
      let obj = stores.user.franchisee
      return obj
    },
    getTeachersData: async function (fid) {
      let url =
        this.franchiseeID
          ? `${constants.API_URL}/api/all/staff-wise?franchiseeID=${this.franchiseeID}`
          : `${constants.API_URL}/api/all/staff-wise`
      try {
        this.isLoading = true
        const { data } = await http.get(url)
        this.total = data.length
        this.staffData = data
        this.staffData.map(a => {
          a.name = `${a.firstName ? a.firstName : ''} ${a.lastName ? a.lastName : ''}`
          a.userStaff.dateOfJoining = a.userStaff.dateOfJoining ? moment(a.userStaff.dateOfJoining, 'YYYY-MM-DD').format('YYYY-MM-DD') : null
          a.userStaff.status =
            a.userStaff.status === 'CH_LEVEL1'
              ? 'Pending for CH1 approval'
              : a.userStaff.status === 'CH_LEVEL2'
                ? 'Pending for CH2 approval'
                : a.userStaff.status === 'CH_LEVEL3'
                  ? 'Pending for CH3 approval'
                  : a.userStaff.status
        })
        this.staffData.forEach((item) => {
          this.exceptionRoles = false
          if (
            item.userStaff.staffDesignation.name === constants.teachingStaff.Organizer ||
            item.userStaff.staffDesignation.name === constants.teachingStaff.Moderator ||
            item.userStaff.staffDesignation.name === constants.teachingStaff.Expert
          ) {
            this.exceptionRoles = true
          }
          item.exceptionRoles = this.exceptionRoles
        }
        )
        this.searchFilterArray = this.staffData
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    addStaff () {
      this.$router.push({ name: 'Staff' })
    }
  }
}
</script>
